import React, { useState, Component } from 'react';
import { StarIcon, DownloadIcon, ShareIcon, ArrowLeftIcon, XIcon, TwitterIcon, LinkedinIcon, FacebookIcon, CopyIcon, ChevronLeftIcon, ChevronRightIcon, PlayIcon, AlertCircleIcon } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { mockApps, mockReviews } from '../utils/mockData';
import { ReviewForm } from '../components/ReviewForm';
export const AppDetail = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [showShareModal, setShowShareModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showDirectOpenModal, setShowDirectOpenModal] = useState(false);
  const app = mockApps.find(a => a.id === id);
  const dummyScreenshots = ['https://cdn.pixabay.com/photo/2023/09/25/16/19/ai-generated-8274699_1280.jpg', 'https://cdn.pixabay.com/photo/2023/09/25/16/20/ai-generated-8274702_1280.jpg', 'https://cdn.pixabay.com/photo/2023/09/25/16/19/ai-generated-8274700_1280.jpg'];
  const shareMessage = `Check out "${app?.title}" on RealUse AI!`;
  const handleShare = (platform: string) => {
    // In a real app, these would use proper sharing APIs
    switch (platform) {
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`, '_blank');
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(window.location.href);
        // You might want to show a toast notification here
        break;
    }
    setShowShareModal(false);
  };
  const handlePrevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? dummyScreenshots.length - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setCurrentImageIndex(prev => prev === dummyScreenshots.length - 1 ? 0 : prev + 1);
  };
  const handleDirectOpen = () => {
    setShowDirectOpenModal(true);
  };
  const handleConfirmDirectOpen = () => {
    setShowDirectOpenModal(false);
    navigate(`/app-interface/${id}`);
  };
  const handleAddToLibrary = () => {
    setShowDirectOpenModal(false);
    // In a real app, this would add to library
    // For now, just navigate to the app
    navigate(`/app-interface/${id}`);
  };
  if (!app) {
    return <div data-id="element-528">App not found</div>;
  }
  return <div className="bg-gray-50 min-h-screen pb-20 md:pb-0" data-id="element-529">
      {/* Back Button */}
      <div className="bg-white border-b border-gray-200 py-4" data-id="element-530">
        <div className="max-w-6xl mx-auto px-4 sm:px-8" data-id="element-531">
          <button onClick={() => navigate(-1)} className="flex items-center text-gray-600 hover:text-indigo-600" data-id="element-532">
            <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-533" />
            <span className="text-sm" data-id="element-534">Back</span>
          </button>
        </div>
      </div>
      {/* App Hero Section */}
      <div className="bg-white border-b border-gray-200" data-id="element-535">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6" data-id="element-536">
          <div className="flex flex-col sm:flex-row sm:items-start sm:space-x-8" data-id="element-537">
            <div className="w-24 h-24 sm:w-32 sm:h-32 bg-indigo-500 rounded-2xl flex items-center justify-center mx-auto sm:mx-0 mb-4 sm:mb-0" data-id="element-538">
              <img src={app.icon === 'image' ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/niZcL1bi9DypZftp1zanDt/RealUseIcon.svg' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/niZcL1bi9DypZftp1zanDt/RealUseIcon.svg'} alt="App Icon" className="w-12 h-12 sm:w-16 sm:h-16" data-id="element-539" />
            </div>
            <div className="flex-1 text-center sm:text-left" data-id="element-540">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between" data-id="element-541">
                <div data-id="element-542">
                  <h1 className="text-xl sm:text-2xl font-bold mb-1" data-id="element-543">
                    {app.title}
                  </h1>
                  <p className="text-gray-500 text-sm sm:text-base" data-id="element-544">
                    By {app.author}
                  </p>
                </div>
                <div className="flex justify-center sm:justify-start space-x-3 mt-4 sm:mt-0" data-id="element-545">
                  <button onClick={handleDirectOpen} className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-md hover:from-indigo-700 hover:to-purple-700 transition-colors flex items-center text-sm sm:text-base shadow-md" data-id="element-546">
                    <PlayIcon className="h-4 w-4 mr-2" data-id="element-547" />
                    Try Now
                  </button>
                  <button onClick={handleAddToLibrary} className="border-2 border-indigo-600 text-indigo-600 px-4 py-2 rounded-md hover:bg-indigo-50 transition-colors flex items-center text-sm sm:text-base" data-id="element-548">
                    <DownloadIcon className="h-4 w-4 mr-2" data-id="element-549" />
                    Add to Library
                  </button>
                  <button onClick={() => setShowShareModal(true)} className="border border-gray-200 px-4 py-2 rounded-md hover:bg-gray-50 transition-colors" data-id="element-550">
                    <ShareIcon className="h-4 w-4" data-id="element-551" />
                  </button>
                </div>
              </div>
              <div className="flex flex-wrap justify-center sm:justify-start items-center mt-4 gap-4 text-sm" data-id="element-552">
                <div className="flex items-center" data-id="element-553">
                  <StarIcon className="h-5 w-5 text-amber-400 fill-amber-400" data-id="element-554" />
                  <span className="ml-1 font-medium" data-id="element-555">{app.rating}</span>
                  <span className="ml-1 text-gray-500" data-id="element-556">
                    ({app.reviews} reviews)
                  </span>
                </div>
                <span className="hidden sm:block text-gray-500" data-id="element-557">|</span>
                <span className="text-gray-500" data-id="element-558">{app.downloads} downloads</span>
                <span className="hidden sm:block text-gray-500" data-id="element-559">|</span>
                <span className="text-gray-500" data-id="element-560">{app.price}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* App Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6 sm:py-8" data-id="element-561">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-562">
          <div className="lg:col-span-2" data-id="element-563">
            {/* Screenshots */}
            <section className="bg-white rounded-lg p-4 sm:p-6 mb-6" data-id="element-564">
              <h2 className="text-lg font-medium mb-4" data-id="element-565">Screenshots</h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4" data-id="element-566">
                {dummyScreenshots.map((screenshot, index) => <button key={index} onClick={() => {
                setCurrentImageIndex(index);
                setShowImageModal(true);
              }} className="aspect-video bg-gray-100 rounded-lg overflow-hidden hover:opacity-90 transition-opacity" data-id="element-567">
                    <img src={screenshot} alt={`Screenshot ${index + 1}`} className="w-full h-full object-cover" data-id="element-568" />
                  </button>)}
              </div>
            </section>
            {/* Description */}
            <section className="bg-white rounded-lg p-4 sm:p-6 mb-6" data-id="element-569">
              <h2 className="text-lg font-medium mb-4" data-id="element-570">Description</h2>
              <p className="text-gray-600 text-sm sm:text-base" data-id="element-571">
                {app.description}
              </p>
            </section>
            {/* Reviews */}
            <section className="bg-white rounded-lg p-4 sm:p-6" data-id="element-572">
              <div className="flex justify-between items-center mb-4" data-id="element-573">
                <h2 className="text-lg font-medium" data-id="element-574">Reviews</h2>
                <button onClick={() => document.getElementById('review-form')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-575">
                  Write a Review
                </button>
              </div>
              {mockReviews.map(review => <div key={review.id} className="border-b border-gray-100 last:border-0 py-4" data-id="element-576">
                  <div className="flex items-center mb-2" data-id="element-577">
                    <div className="w-8 h-8 bg-gray-200 rounded-full mr-3" data-id="element-578"></div>
                    <div data-id="element-579">
                      <p className="font-medium text-sm" data-id="element-580">{review.userName}</p>
                      <div className="flex items-center" data-id="element-581">
                        {Array(5).fill(null).map((_, j) => <StarIcon key={j} className={`h-3.5 w-3.5 sm:h-4 sm:w-4 ${j < review.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`} data-id="element-582" />)}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm sm:text-base" data-id="element-583">
                    {review.comment}
                  </p>
                </div>)}
              <div id="review-form" data-id="element-584">
                <ReviewForm data-id="element-585" />
              </div>
            </section>
          </div>
          {/* Sidebar */}
          <div className="order-first lg:order-last" data-id="element-586">
            <div className="bg-white rounded-lg p-4 sm:p-6 sticky top-4" data-id="element-587">
              <h3 className="font-medium mb-4" data-id="element-588">Additional Information</h3>
              <dl className="space-y-4 text-sm" data-id="element-589">
                <div data-id="element-590">
                  <dt className="text-gray-500" data-id="element-591">Category</dt>
                  <dd className="mt-1 font-medium" data-id="element-592">{app.category}</dd>
                </div>
                <div data-id="element-593">
                  <dt className="text-gray-500" data-id="element-594">Created By</dt>
                  <dd className="mt-1 font-medium" data-id="element-595">{app.createdBy}</dd>
                </div>
                <div data-id="element-596">
                  <dt className="text-gray-500" data-id="element-597">AIs Used</dt>
                  <dd className="mt-1 font-medium" data-id="element-598">{app.aisUsed.join(', ')}</dd>
                </div>
                <div data-id="element-599">
                  <dt className="text-gray-500" data-id="element-600">Updated</dt>
                  <dd className="mt-1 font-medium" data-id="element-601">{app.updated}</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
      {/* Direct Open Warning Modal */}
      {showDirectOpenModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-602">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden" data-id="element-603">
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-6" data-id="element-604">
              <div className="flex items-center space-x-3" data-id="element-605">
                <div className="bg-white/20 p-3 rounded-xl" data-id="element-606">
                  <AlertCircleIcon className="h-8 w-8 text-white" data-id="element-607" />
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-608">
                  Quick Start Mode
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-609">
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-610">
                Opening an app directly will not save previous records and
                entries. If you wish to keep usage history and access your
                conversations later, please add this application to My Apps.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-611">
                <div className="flex items-start space-x-2" data-id="element-612">
                  <AlertCircleIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-613" />
                  <div className="text-sm text-blue-800" data-id="element-614">
                    <p className="font-medium mb-1" data-id="element-615">What this means:</p>
                    <ul className="space-y-1 text-xs" data-id="element-616">
                      <li data-id="element-617">• Your conversations won't be saved</li>
                      <li data-id="element-618">• You can't access history later</li>
                      <li data-id="element-619">• Perfect for quick, one-time use</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-620">
                <button onClick={handleAddToLibrary} className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-3 rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all font-medium shadow-md flex items-center justify-center" data-id="element-621">
                  <DownloadIcon className="h-5 w-5 mr-2" data-id="element-622" />
                  Add to My Apps
                </button>
                <button onClick={handleConfirmDirectOpen} className="w-full border-2 border-gray-300 text-gray-700 px-6 py-3 rounded-xl hover:bg-gray-50 transition-colors font-medium flex items-center justify-center" data-id="element-623">
                  <PlayIcon className="h-5 w-5 mr-2" data-id="element-624" />
                  Open Directly
                </button>
                <button onClick={() => setShowDirectOpenModal(false)} className="w-full text-gray-500 hover:text-gray-700 text-sm font-medium py-2 transition-colors" data-id="element-625">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Share Modal */}
      {showShareModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-626">
          <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-sm mx-4" data-id="element-627">
            <div className="flex justify-between items-center mb-4" data-id="element-628">
              <h3 className="text-lg font-medium" data-id="element-629">Share App</h3>
              <button onClick={() => setShowShareModal(false)} className="text-gray-500 hover:text-gray-700 p-1" data-id="element-630">
                <XIcon className="h-5 w-5" data-id="element-631" />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-3" data-id="element-632">
              <button onClick={() => handleShare('twitter')} className="flex items-center justify-center space-x-2 p-2 border rounded-md hover:bg-gray-50" data-id="element-633">
                <TwitterIcon className="h-5 w-5 text-blue-400" data-id="element-634" />
                <span className="text-sm" data-id="element-635">Twitter</span>
              </button>
              <button onClick={() => handleShare('linkedin')} className="flex items-center justify-center space-x-2 p-2 border rounded-md hover:bg-gray-50" data-id="element-636">
                <LinkedinIcon className="h-5 w-5 text-blue-700" data-id="element-637" />
                <span className="text-sm" data-id="element-638">LinkedIn</span>
              </button>
              <button onClick={() => handleShare('facebook')} className="flex items-center justify-center space-x-2 p-2 border rounded-md hover:bg-gray-50" data-id="element-639">
                <FacebookIcon className="h-5 w-5 text-blue-600" data-id="element-640" />
                <span className="text-sm" data-id="element-641">Facebook</span>
              </button>
              <button onClick={() => handleShare('copy')} className="flex items-center justify-center space-x-2 p-2 border rounded-md hover:bg-gray-50" data-id="element-642">
                <CopyIcon className="h-5 w-5 text-gray-600" data-id="element-643" />
                <span className="text-sm" data-id="element-644">Copy Link</span>
              </button>
            </div>
          </div>
        </div>}
      {/* Screenshot Modal */}
      {showImageModal && <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50" data-id="element-645">
          <button onClick={() => setShowImageModal(false)} className="absolute top-4 right-4 text-white hover:text-gray-300 p-2" aria-label="Close" data-id="element-646">
            <XIcon className="h-6 w-6" data-id="element-647" />
          </button>
          <button onClick={handlePrevImage} className="absolute left-2 sm:left-4 text-white hover:text-gray-300 p-2" aria-label="Previous image" data-id="element-648">
            <ChevronLeftIcon className="h-6 w-6 sm:h-8 sm:w-8" data-id="element-649" />
          </button>
          <button onClick={handleNextImage} className="absolute right-2 sm:right-4 text-white hover:text-gray-300 p-2" aria-label="Next image" data-id="element-650">
            <ChevronRightIcon className="h-6 w-6 sm:h-8 sm:w-8" data-id="element-651" />
          </button>
          <div className="w-full h-full flex items-center justify-center p-4" data-id="element-652">
            <img src={dummyScreenshots[currentImageIndex]} alt={`Screenshot ${currentImageIndex + 1}`} className="max-h-[85vh] max-w-[85vw] object-contain" data-id="element-653" />
          </div>
          <div className="absolute bottom-4 left-0 right-0 text-white text-sm text-center" data-id="element-654">
            {currentImageIndex + 1} / {dummyScreenshots.length}
          </div>
        </div>}
    </div>;
};